$ = require('jquery');
const { detect } = require('detect-browser');
global.browser = detect();

global.kosketus = ('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0);

import Etusivu from './parts/etusivu';
import Calendar from './parts/calendar';

$(function(){
  $('html').addClass(browser.name);
  console.log('app js imastaan OK');

  $('html').css('--vh', window.innerHeight/100+'px');
  global.mainW = $('#wrap').outerWidth();

  if(window.isHome){
    if(window.kosketus) {
      $('html').addClass('touch');
    }

    new Etusivu();
  }

  if(window.location.pathname.indexOf('calendar')>=0){
    new Calendar();
  }

  $(window).resize(function(){
    if($('#wrap').outerWidth() !== global.mainW){
      this.mainW = $('#wrap').outerWidth();
      $('html').css('--vh', window.innerHeight/100+'px');
    }
  });

  $(window).on('pageshow load', function(){
    $('#wrap').addClass('in');
  });

  setTimeout(function(){
    $('#wrap').addClass('in');
  }, 500);

  $('#footer a, .logolink').click(function(e){
    e.preventDefault();
    var a = $(this).attr('href');
    $('#wrap').removeClass('in');
    setTimeout(function(){
      window.location.href = a;
    }, 500)
    // console.log(a);
  });
});
